import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const galleryItems = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/bakery_storefront_wordpress.png",
  alt: "A charming bakery storefront website built with AI",
  caption: "Small Business",
  spanClasses: "md:col-span-2 md:row-span-2"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/community_center_portal.png",
  alt: "A vibrant community center website layout",
  caption: "Community",
  spanClasses: "md:col-span-1 md:row-span-1"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/tech_blog_modern.png",
  alt: "Sleek tech blog with dark mode interface",
  caption: "Tech Blog",
  spanClasses: "md:col-span-1 md:row-span-2"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/ecommerce_fashion_store.png",
  alt: "High-end fashion ecommerce site",
  caption: "E-commerce",
  spanClasses: "md:col-span-2 md:row-span-1"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/personal_portfolio_creative.png",
  alt: "Creative personal portfolio for a designer",
  caption: "Portfolio",
  spanClasses: "md:col-span-1 md:row-span-1"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/local_club_membership.png",
  alt: "Membership site for a local sports club",
  caption: "Clubs",
  spanClasses: "md:col-span-1 md:row-span-1"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670234/img/saas_landing_page.png",
  alt: "Clean SaaS landing page with modern UI",
  caption: "SaaS",
  spanClasses: "md:col-span-2 md:row-span-1"
}];
export default function VisualPoetry() {
  return <section data-section-id="221544" id="built-for-every-creator" className="bg-background text-foreground py-24 px-4 md:px-8 lg:px-12 overflow-hidden relative">
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tighter mb-6 text-secondary">
            Built for Every Creator
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed font-default">
            From local bakeries to global tech blogs, Webshingle transforms your vision into a professional WordPress site. Simple, fast, and fully customizable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-4 auto-rows-[250px] md:auto-rows-[300px] grid-flow-dense">
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className={`relative group overflow-hidden bg-muted rounded-lg shadow-md ${item.spanClasses}`}>
              <img src={item.src} alt={item.alt} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-secondary/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out flex flex-col items-center justify-center p-6 backdrop-blur-sm">
                <div className="bg-primary text-primary-foreground px-3 py-1 rounded-md text-xs font-bold mb-4 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out">
                  {item.caption}
                </div>
                <Button variant="default" size="sm" className="font-default rounded-md shadow-lg translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out delay-75">
                  View Template
                </Button>
              </div>
            </div>)}
        </div>

        <div className="mt-20 flex justify-center">
          <Button size="lg" variant="default" className="px-8 py-6 text-lg font-default rounded-lg shadow-xl hover:shadow-2xl transition-all" asChild>
            <Link to="/PricingPage">Start Your 7-Day Free Trial</Link>
          </Button>
        </div>
      </div>
    </section>;
}